import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AppTranslateService {
  private currentLanguage = new BehaviorSubject<string>('pt');
  public currentLanguage$ = this.currentLanguage.asObservable();

  constructor(private translateService: TranslateService) {
    this.initialize();
  }

  private initialize(): void {
    this.translateService.addLangs(['pt', 'es']);
    this.translateService.setDefaultLang('pt');

    if (!this.translateService.currentLang) {
      this.translateService.use('pt').subscribe(() => {
        this.currentLanguage.next('pt');
      });
    } else {
      this.currentLanguage.next(this.translateService.currentLang);
    }
  }

  changeLanguage(lang: string): void {
    const availableLangs = this.translateService.getLangs();
    
    if (availableLangs.includes(lang) && this.translateService.currentLang !== lang) {
      this.translateService.use(lang).subscribe({
        next: () => {
          if (this.translateService.currentLang === lang) {
            this.currentLanguage.next(lang);
          }
        },
        error: (err) => {
          console.error('Erro ao alterar idioma:', err);
        }
      });
    }
  }

  getCurrentLanguage(): string {
    return this.currentLanguage.value;
  }

  getTranslation(key: string): Observable<string> {
    return this.translateService.get(key);
  }
}
